(function () {
    angular.module('env.customConfig',
        [
            'env.customConfig.provider',
            'env.customConfig.templates',
            'env.customConfig.directives',
            'env.customConfig.images',
            'env.customConfig.styles',
            'env.customConfig.configs',
            'env.customConfig.reports',
            'env.customConfig.workflow',
            'env.customConfig.logicResolvers'
        ])
        .run(function ($log, $customisationConfig) {
            $customisationConfig.initCustomResourcesMap();

            // validate customisationConfig sections
            if (angular.isUndefined($customisationConfig)) {
                $log.error('Wrong customisation config! Check please `customise/config*.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.directives)) {
                $log.error('Wrong customisation config: directives! Check please `customise/configDirectives.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.images)) {
                $log.error('Wrong customisation config: images! Check please `customise/configImages.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.templates)) {
                $log.error('Wrong customisation config: templates! Check please `customise/configTemplates.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.styles)) {
                $log.error('Wrong customisation config: styles! Check please `customise/configStyles.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.configs)) {
                $log.error('Wrong customisation config: configs! Check please `customise/configConfigs.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.reports)) {
                $log.error('Wrong customisation config: reports! Check please `customise/configReports.js` and any dependant configuration files.');
            }
            if (angular.isUndefined($customisationConfig.workflow)) {
                $log.error('Wrong customisation config: workflow! Check please `customise/configWorkflow.js` and any dependant configuration files.');
            }
        });

    angular.module('env.customConfig.provider', [])
        .constant('servertext', function (str) {
            /*
             * Does nothing, simply returns the input string.
             *
             * This function serves as a marker for gulp tasks `export-server-translations` to know that
             * this string should be extracted for OrderManager server translations.
             */
            return str;
        })
        .provider('$customisationConfig', function CustomisationConfigProvider() {
            /**
             * Whenever instance of the CustomisationConfig will be requested from its provider, it will be given the content of the
             * predefined configurations supplied via the .config() function calls in the corresponding configuration sub-modules.
             */
            this.$get = function ($log, $http) {

                return new CustomisationConfig($log, $http, this.templates, this.directives, this.images, this.styles, this.configs, this.reports, this.workflow);
            };
        }
    );

    /**
     * Provides the access points to all of the config sections of the customisation subsystem throughout the application.
     */
    function CustomisationConfig($log, $http, templates, directives, images, styles, configs, reports, workflow) {
        var _this = this;
        var log = $log;
        var http = $http;

        this.templates = templates;
        this.directives = directives;
        this.images = images;
        this.styles = styles;
        this.configs = configs;
        this.reports = reports;
        this.workflow = workflow;

        var downloadCustomResourcesMap = function () {
            return http.get('api/customisedresources/map')
                .then(function (resp) {
                    log.debug("Downloaded customised resources map from the server and cached.");
                    return resp.data;
                })
                .catch(function (error) {
                    log.error(_.string.sprintf("Can't download customised resources map [%s] from the server: %s %s",
                        error.config.url, error.status, error.statusText));
                    return [];
                });
        };

        this.initCustomResourcesMap = function () {
            downloadCustomResourcesMap().then(function (resMap) {
                _this.customResourcesMap = resMap;
            });
        };

        this.hasResource = function (predicate) {
            return angular.isDefined(_.find(_this.customResourcesMap, predicate));
        };
    }
})();